import { FormHelperText } from "@material-ui/core"
import { CheckBoxOutlineBlankOutlined } from "@material-ui/icons"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import { Field, useFormikContext } from "formik"
import { CheckboxWithLabel } from "formik-material-ui"
import React, { useState } from "react"
import styled from "styled-components"

const StyledContainer = styled.div`
  display: flex;
  .MuiFormControlLabel-root {
    display: flex;
    align-items: center;
    margin-right: 0px;
    margin-left: 0px;
  }

  .MuiFormControlLabel-label {
    text-align: start !important;
  }

  .MuiIconButton-label {
    border-radius: 4px;
    svg {
      border-radius: 4px;
    }
  }

  :hover {
    .MuiIconButton-label {
      box-shadow: 0 0 0 1px grey;
    }
  }
`

const StyledCheckboxWithLabel = styled(CheckboxWithLabel)`
  padding: 0;

  margin-left: 7px;
`

const StyledError = styled(FormHelperText)`
  bottom: -0.5em;

  right: 0px;

  text-align: start !important;

  font-size: 18px !important;
  position: absolute;
  top: 25px;
  right: 30px;
  font-family: NarkisBlock-Thin;
`

export interface FormikCheckboxFieldProps {
  name: string
  label?: React.ReactNode
  required?: boolean
  inputRef?: React.RefObject<HTMLButtonElement>
  children?: React.ReactNode
  normalIcon?: JSX.Element
  checkedIcon?: JSX.Element
  checked?: boolean
  ariaLabel?: string
  ariaDescribedBy?: string
}

const FormikCheckbox = ({
  name,
  label,
  required,
  inputRef,
  children,
  normalIcon,
  checkedIcon,
  checked,
  ariaLabel,
  ariaDescribedBy,
  ...props
}: FormikCheckboxFieldProps) => {
  const { errors, touched } = useFormikContext<{ [field: string]: boolean }>()
  const [isChecked, setIsChecked] = useState(false)

  return (
    <div>
      <StyledContainer>
        <Field
          component={StyledCheckboxWithLabel}
          type="checkbox"
          required={required}
          icon={
            normalIcon ? (
              normalIcon
            ) : (
              <CheckBoxOutlineBlankOutlined fontSize="small" color="inherit" />
            )
          }
          checkedIcon={
            checkedIcon ? (
              checkedIcon
            ) : (
              <CheckBoxIcon fontSize="small" color="inherit" />
            )
          }
          name={name}
          Label={{ label, style: { marginLeft: 0 } }}
          inputRef={inputRef}
          inputProps={{
            "aria-describedby": ariaDescribedBy || `${name}-helper-text`,
            "aria-label": ariaLabel,
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") setIsChecked(!isChecked)
          }}
          checked={checked}
          onClick={() => setIsChecked(!isChecked)}
          {...props}
        />
        {children}
      </StyledContainer>

      {errors[name] && touched[name] && (
        <StyledError id={`${name}-helper-text`} error>
          {errors[name]}
        </StyledError>
      )}
    </div>
  )
}

export default FormikCheckbox
